(function () {
  'use strict';

  var VERCEL_URL = 'https://toptankahve-checkout.vercel.app';
  var TOTAL_STEPS = 4;

  var config = {};
  var state = {
    step: 1,
    beanStructure: null,  // 'single' | 'blend'
    beans: [
      { beanId: null, ratio: 100 },
      { beanId: null, ratio: 0 },
      { beanId: null, ratio: 0 },
    ],
    kg: 10,
    frequency: null,
    duration: null,
    customerName: '',
    customerEmail: '',
    customerPhone: '',
  };

  var contentEl = null;

  /* ── Boot ── */
  function init() {
    var cfgEl = document.getElementById('subscription-wizard-config');
    if (!cfgEl) return;
    try { config = JSON.parse(cfgEl.textContent); } catch (e) { return; }

    // Sunucudan çekirdek başına HAZIR satış fiyatlarını (TL/kg) çek —
    // ham maliyet/kur/çarpan istemciye hiç inmez. Geçici ağ/API hatasına
    // karşı artan aralıklarla yeniden dener; adım da yeniden çizilir ki
    // fiyatlar geç gelirse görünüm güncellensin.
    (function loadPrices(attempt) {
      fetch(VERCEL_URL + '/api/pricing-config')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d || !d.prices) throw new Error('fiyat yanıtı boş');
          config.serverPrices = d.prices;
          config.outOfStock   = d.outOfStock || [];
          try {
            // Kullanıcı bir alana yazıyorsa adımı yeniden çizme (odak kaybolur);
            // fiyatlar bir sonraki adım geçişinde zaten güncel çizilir.
            var ae = document.activeElement;
            var typing = ae && contentEl && contentEl.contains(ae) &&
              /^(INPUT|SELECT|TEXTAREA)$/.test(ae.tagName);
            if (!typing) renderStep(state.step);
            updateAside();
          } catch (e) {}
        })
        .catch(function () {
          var delays = [1000, 3000, 8000, 15000];
          if (attempt < delays.length) {
            setTimeout(function () { loadPrices(attempt + 1); }, delays[attempt]);
          }
        });
    })(0);

    contentEl = document.getElementById('sw-step-content');
    document.getElementById('sw-prev').addEventListener('click', prevStep);
    document.getElementById('sw-next').addEventListener('click', nextStep);
    document.getElementById('sw-aside-order').addEventListener('click', createSubscription);

    renderStep(1);
    updateAside();
  }

  /* ── Navigation ── */
  function prevStep() {
    if (state.step > 1) { state.step--; renderStep(state.step); updateAside(); }
  }

  function nextStep() {
    var err = validateStep(state.step);
    if (err) { showError(err); return; }
    clearError();
    if (state.step < TOTAL_STEPS) { state.step++; renderStep(state.step); updateAside(); }
    else createSubscription();
  }

  function validateStep(step) {
    if (step === 1) {
      if (!state.beanStructure) return 'Lütfen çekirdek yapısı seçin.';
      var selected = selectedBeans();
      if (!selected.length) return 'En az bir çekirdek seçin.';
      if (state.beanStructure === 'blend') {
        var ratioSum = selected.reduce(function (s, b) { return s + b.ratio; }, 0);
        if (ratioSum !== 100) return 'Oran toplamı 100 olmalıdır (şu an: ' + ratioSum + ').';
      }
    }
    if (step === 2) {
      if (!state.frequency) return 'Teslimat sıklığı seçin.';
      if (!state.duration) return 'Abonelik süresi seçin.';
    }
    if (step === 3) {
      if (!state.customerName.trim()) return 'Ad Soyad zorunludur.';
      if (!state.customerEmail.trim() || !state.customerEmail.includes('@')) return 'Geçerli bir e-posta girin.';
    }
    return null;
  }

  /* ── Render ── */
  function renderStep(step) {
    updateStepNav(step);
    updateProgress(step);
    var prev = document.getElementById('sw-prev');
    var next = document.getElementById('sw-next');
    prev.style.visibility = step === 1 ? 'hidden' : 'visible';
    next.textContent = step === TOTAL_STEPS ? 'Abonelik Oluştur ve Öde →' : 'İleri →';

    if (step === 1) renderBeanStep();
    else if (step === 2) renderDeliveryStep();
    else if (step === 3) renderCustomerStep();
    else if (step === 4) renderSummaryStep();
  }

  function updateStepNav(step) {
    document.querySelectorAll('.sw-step-btn').forEach(function (btn) {
      var s = parseInt(btn.dataset.step);
      btn.classList.toggle('active', s === step);
      btn.classList.toggle('done', s < step);
    });
  }

  function updateProgress(step) {
    var pct = ((step - 1) / (TOTAL_STEPS - 1)) * 100;
    document.getElementById('sw-progress-bar').style.width = pct + '%';
  }

  /* ── Step 1: Çekirdek ── */
  function renderBeanStep() {
    var html = '<div class="sw-step">';
    html += '<h2>Çekirdek Seçimi</h2>';
    html += '<p class="sw-subtitle">Aboneliğinizde hangi kahveyi almak istiyorsunuz?</p>';

    // Yapı seçimi
    html += '<div class="sw-structure-grid">';
    html += '<div class="sw-structure-card' + (state.beanStructure === 'single' ? ' selected' : '') + '" data-struct="single">';
    html += '<h4>Tek Çekirdek</h4><p>Tek bir orijin kahve</p></div>';
    html += '<div class="sw-structure-card' + (state.beanStructure === 'blend' ? ' selected' : '') + '" data-struct="blend">';
    html += '<h4>Özel Blend</h4><p>2-3 çekirdek karışımı</p></div>';
    html += '</div>';

    if (state.beanStructure) {
      var beanCount = state.beanStructure === 'single' ? 1 : 3;
      var showAdd = state.beanStructure === 'blend';

      html += '<div id="sw-bean-rows">';
      for (var i = 0; i < beanCount; i++) {
        html += renderBeanRow(i, state.beanStructure === 'blend');
      }
      html += '</div>';

      if (showAdd && activeBeanCount() < 3) {
        html += '<button class="sw-add-bean-btn" id="sw-add-bean">+ Çekirdek Ekle</button>';
      }
    }

    html += '</div>';
    contentEl.innerHTML = html;

    // Events
    contentEl.querySelectorAll('.sw-structure-card').forEach(function (card) {
      card.addEventListener('click', function () {
        state.beanStructure = card.dataset.struct;
        if (state.beanStructure === 'single') {
          state.beans[1] = { beanId: null, ratio: 0 };
          state.beans[2] = { beanId: null, ratio: 0 };
          state.beans[0].ratio = 100;
        } else {
          if (!state.beans[0].ratio) state.beans[0].ratio = 60;
          if (!state.beans[1].ratio) state.beans[1].ratio = 40;
        }
        renderStep(1); updateAside();
      });
    });

    contentEl.querySelectorAll('.sw-bean-sel').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var idx = parseInt(sel.dataset.idx);
        state.beans[idx].beanId = sel.value || null;
        updateAside();
      });
    });

    // Elle rakam girilemez: oran yalnızca 10'luk adımlarla 10-90 arasında
    // değişir (küsuratlı/serbest girişle oynanmasın diye).
    contentEl.querySelectorAll('.sw-ratio-btn').forEach(function (b) {
      b.addEventListener('click', function () {
        var idx  = parseInt(b.dataset.idx);
        if (!state.beans[idx]) return;
        var cur  = parseInt(state.beans[idx].ratio) || 0;
        var next = cur + (parseInt(b.dataset.dir) * 10);
        state.beans[idx].ratio = Math.max(10, Math.min(90, next));
        renderStep(state.step);
        updateAside();
      });
    });

    var addBtn = document.getElementById('sw-add-bean');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        for (var i = 0; i < 3; i++) {
          if (!state.beans[i].beanId && i > 0) {
            state.beans[i].ratio = 10;
            break;
          }
        }
        renderStep(1);
      });
    }
  }

  function renderBeanRow(idx, showRatio) {
    var bean = state.beans[idx];
    var beans = config.beans || [];
    var showRow = idx === 0 || bean.beanId !== null || (idx === 1 && activeBeanCount() >= 1);
    if (idx > 0 && !showRow && idx !== 1) return '';
    if (idx === 2 && activeBeanCount() < 2) return '';

    var html = '<div class="sw-blend-row" id="sw-row-' + idx + '">';
    html += '<div class="sw-bean-select">';
    html += '<label>' + (showRatio ? (idx + 1) + '. Çekirdek' : 'Çekirdek Seçin') + '</label>';
    html += '<select class="sw-bean-sel" data-idx="' + idx + '">';
    html += '<option value="">-- Çekirdek seçin --</option>';
    beans.forEach(function (b) {
      var oos = (config.outOfStock || []).indexOf(b.id) !== -1;
      html += '<option value="' + b.id + '"' + (bean.beanId === b.id ? ' selected' : '') + (oos ? ' disabled' : '') + '>';
      html += b.name + ' (' + b.country + ')' + (oos ? ' - stok dışı' : '');
      html += '</option>';
    });
    html += '</select></div>';

    if (showRatio) {
      html += '<div>';
      html += '<div class="sw-ratio-label">Oran %</div>';
      html += '<div class="sw-ratio-stepper">';
      html += '<button type="button" class="sw-qty-btn sw-ratio-btn" data-idx="' + idx + '" data-dir="-1" aria-label="Oranı 10 azalt">−</button>';
      html += '<span class="sw-ratio-val">%' + (parseInt(bean.ratio) || 0) + '</span>';
      html += '<button type="button" class="sw-qty-btn sw-ratio-btn" data-idx="' + idx + '" data-dir="1" aria-label="Oranı 10 artır">+</button>';
      html += '</div>';
      html += '</div>';
    }
    html += '</div>';
    return html;
  }

  function activeBeanCount() {
    return state.beans.filter(function (b) { return b.beanId; }).length;
  }

  /* ── Step 2: Teslimat ── */
  function renderDeliveryStep() {
    var freqOpts  = config.frequencyOptions || [];
    var durOpts   = config.durationOptions  || [];
    var totalDel  = calcTotalDeliveries();

    var html = '<div class="sw-step">';
    html += '<h2>Teslimat Planı</h2>';
    html += '<p class="sw-subtitle">Her teslimat için miktar, sıklık ve süreyi belirleyin.</p>';

    // Miktar
    html += '<div class="sw-field"><label>Her Teslimat · Miktar (kg)</label>';
    html += '<div class="sw-qty-row">';
    html += '<button class="sw-qty-btn" id="sw-qty-minus">−</button>';
    html += '<div class="sw-qty-val" id="sw-qty-val">' + state.kg + '</div>';
    html += '<button class="sw-qty-btn" id="sw-qty-plus">+</button>';
    html += '</div><div class="sw-hint">Min 10 kg, adım 5 kg</div></div>';

    // Sıklık
    html += '<div class="sw-field"><label>Teslimat Sıklığı</label>';
    html += '<div class="sw-option-grid">';
    freqOpts.forEach(function (f) {
      html += '<div class="sw-option-card' + (state.frequency === f.value ? ' selected' : '') + '" data-freq="' + f.value + '">';
      html += '<div class="sw-opt-label">' + f.label + '</div></div>';
    });
    html += '</div></div>';

    // Süre
    html += '<div class="sw-field"><label>Abonelik Süresi</label>';
    html += '<div class="sw-option-grid two-col">';
    durOpts.forEach(function (d) {
      html += '<div class="sw-option-card' + (state.duration === d.months ? ' selected' : '') + '" data-dur="' + d.months + '">';
      html += '<div class="sw-opt-label">' + d.label + '</div>';
      html += '</div>';
    });
    html += '</div></div>';

    if (state.frequency && state.duration) {
      var td = calcTotalDeliveries();
      html += '<div style="background:#f0faf5;border-radius:8px;padding:14px 16px;font-size:14px;color:#2d6a4f;font-weight:500;">';
      html += '📦 Toplam ' + td + ' teslimat · ' + state.kg + ' kg × ' + td + ' = ' + (state.kg * td) + ' kg';
      html += '</div>';
    }

    html += '</div>';
    contentEl.innerHTML = html;

    // Events
    document.getElementById('sw-qty-minus').addEventListener('click', function () {
      state.kg = Math.max(10, state.kg - 5);
      document.getElementById('sw-qty-val').textContent = state.kg;
      updateAside();
    });
    document.getElementById('sw-qty-plus').addEventListener('click', function () {
      state.kg = Math.min(200, state.kg + 5);
      document.getElementById('sw-qty-val').textContent = state.kg;
      updateAside();
    });

    contentEl.querySelectorAll('[data-freq]').forEach(function (el) {
      el.addEventListener('click', function () {
        state.frequency = el.dataset.freq;
        renderStep(2); updateAside();
      });
    });
    contentEl.querySelectorAll('[data-dur]').forEach(function (el) {
      el.addEventListener('click', function () {
        state.duration = parseInt(el.dataset.dur);
        renderStep(2); updateAside();
      });
    });
  }

  /* ── Step 3: Müşteri Bilgileri ── */
  function renderCustomerStep() {
    var html = '<div class="sw-step">';
    html += '<h2>İletişim Bilgileri</h2>';
    html += '<p class="sw-subtitle">Teslimatlarınız için iletişim bilgilerinizi girin.</p>';

    html += '<div class="sw-input-group"><label>Ad Soyad</label>';
    html += '<input type="text" id="sw-name" placeholder="Ad Soyad" value="' + esc(state.customerName) + '" autocomplete="name"></div>';

    html += '<div class="sw-input-group"><label>E-posta</label>';
    html += '<input type="email" id="sw-email" placeholder="ornek@sirket.com" value="' + esc(state.customerEmail) + '" autocomplete="email"></div>';

    html += '<div class="sw-input-group"><label>Telefon <span class="sw-optional">(opsiyonel)</span></label>';
    html += '<input type="tel" id="sw-phone" placeholder="+90 5XX XXX XX XX" value="' + esc(state.customerPhone) + '" autocomplete="tel"></div>';

    html += '</div>';
    contentEl.innerHTML = html;

    document.getElementById('sw-name').addEventListener('input', function (e) { state.customerName = e.target.value; });
    document.getElementById('sw-email').addEventListener('input', function (e) { state.customerEmail = e.target.value; });
    document.getElementById('sw-phone').addEventListener('input', function (e) { state.customerPhone = e.target.value; });
  }

  /* ── Step 4: Özet ── */
  function renderSummaryStep() {
    var sel  = selectedBeans();
    var total = calcTotalAmount();
    var td    = calcTotalDeliveries();
    var freqLabel = freqLabel_();
    var durLabel  = state.duration + ' Ay';

    var html = '<div class="sw-step">';
    html += '<h2>Özet & Ödeme</h2>';
    html += '<p class="sw-subtitle">Aboneliğinizi gözden geçirin ve ödemeye geçin.</p>';

    html += '<table class="sw-summary-table">';
    html += '<tr><td>Çekirdek</td><td>' + sel.map(function (b) {
      var bd = findBean(b.beanId);
      return (bd ? bd.name : b.beanId) + (state.beanStructure === 'blend' ? ' %' + b.ratio : '');
    }).join('<br>') + '</td></tr>';
    html += '<tr><td>Her teslimat</td><td>' + state.kg + ' kg</td></tr>';
    html += '<tr><td>Sıklık</td><td>' + freqLabel + '</td></tr>';
    html += '<tr><td>Süre</td><td>' + durLabel + '</td></tr>';
    html += '<tr><td>Toplam teslimat</td><td>' + td + ' kez</td></tr>';
    html += '<tr><td>Toplam miktar</td><td>' + (state.kg * td) + ' kg</td></tr>';
    html += '<tr><td>Müşteri</td><td>' + esc(state.customerName) + '<br><span style="font-weight:400;color:#666">' + esc(state.customerEmail) + '</span></td></tr>';
    html += '</table>';

    if (total > 0) {
      var pricePerKg = calcPricePerKg();
      html += '<div class="sw-price-box">';
      html += '<div class="sw-price-label">Kilitli Birim Fiyat: ' + pricePerKg.toLocaleString('tr-TR', { maximumFractionDigits: 2 }) + ' TL/kg</div>';
      html += '<div class="sw-price-total">' + total.toLocaleString('tr-TR', { maximumFractionDigits: 2 }) + ' TL</div>';
      html += '<div class="sw-price-sub">Tek seferlik ödeme · ' + td + ' teslimat dahil</div>';
      html += '</div>';
      html += '<div class="sw-lock-notice">🔒 Bu fiyat abonelik boyunca sabitlenir. Kur veya maliyet değişimlerinden etkilenmez.</div>';
    }

    html += '</div>';
    contentEl.innerHTML = html;
  }

  /* ── Aside ── */
  function updateAside() {
    var rows   = document.getElementById('sw-summary-rows');
    var panel  = document.getElementById('sw-price-panel');
    var btn    = document.getElementById('sw-aside-order');
    var asideBtn = document.getElementById('sw-aside-order');

    var sel = selectedBeans();
    var rowsHtml = '';

    if (sel.length) {
      rowsHtml += '<div class="sw-summary-row"><span class="sw-row-key">Çekirdek</span><span class="sw-row-val">' +
        sel.map(function (b) { var bd = findBean(b.beanId); return bd ? bd.name.split(' ').slice(0,2).join(' ') : ''; }).join(', ') + '</span></div>';
    }
    if (state.kg) {
      rowsHtml += '<div class="sw-summary-row"><span class="sw-row-key">Miktar</span><span class="sw-row-val">' + state.kg + ' kg/teslimat</span></div>';
    }
    if (state.frequency) {
      rowsHtml += '<div class="sw-summary-row"><span class="sw-row-key">Sıklık</span><span class="sw-row-val">' + freqLabel_() + '</span></div>';
    }
    if (state.duration) {
      rowsHtml += '<div class="sw-summary-row"><span class="sw-row-key">Süre</span><span class="sw-row-val">' + state.duration + ' Ay</span></div>';
    }
    rows.innerHTML = rowsHtml;

    var total = calcTotalAmount();
    var td = calcTotalDeliveries();

    if (total > 0 && state.step >= 2) {
      panel.innerHTML = '<div class="sw-aside__total-label">Toplam Tutar</div>' +
        '<div class="sw-aside__total">' + total.toLocaleString('tr-TR', { maximumFractionDigits: 2 }) + ' TL</div>' +
        (td ? '<div style="font-size:12px;color:#aaa;margin-top:4px">' + td + ' teslimat × ' + state.kg + ' kg</div>' : '');
    } else {
      panel.innerHTML = '<p class="sw-price__hint">Seçimlerinizi yapınca fiyat burada görünür.</p>';
    }

    var ready = sel.length > 0 && state.frequency && state.duration && state.customerName && state.customerEmail;
    btn.disabled = !ready;
    btn.textContent = ready ? 'Abonelik Oluştur ve Öde' : 'Abonelik Oluştur';
  }

  /* ── Ödeme ── */
  function createSubscription(agreementAcceptedAt) {
    var err = validateStep(state.step);
    if (err) { showError(err); return; }

    var allValid = !validateStep(1) && !validateStep(2) && !validateStep(3);
    if (!allValid) {
      showError('Lütfen tüm adımları tamamlayın.');
      return;
    }

    // Abonelik Sözleşmesi onayı zorunlu: modal onayından ISO string gelmeden
    // (click event objesi onay sayılmaz) ödemeye geçilmez; sunucu da reddeder.
    if (typeof agreementAcceptedAt !== 'string') {
      if (typeof window.tkahveAgreementConfirm !== 'function') {
        showError('Sözleşme onay penceresi yüklenemedi. Lütfen sayfayı yenileyip tekrar deneyin.');
        return;
      }
      window.tkahveAgreementConfirm(createSubscription);
      return;
    }

    var btn      = document.getElementById('sw-next');
    var asideBtn = document.getElementById('sw-aside-order');
    if (btn)      { btn.disabled = true;      btn.textContent      = 'İşleniyor...'; }
    if (asideBtn) { asideBtn.disabled = true; asideBtn.textContent = 'İşleniyor...'; }

    var sel = selectedBeans();

    var blendDetails = {
      beans: sel.map(function (b) {
        var bd = findBean(b.beanId);
        return { id: b.beanId, ratio: b.ratio, name: bd ? bd.name : b.beanId };
      }),
      structure: state.beanStructure,
    };

    fetch(VERCEL_URL + '/api/create-subscription', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        customerId:        (window.tkahveCustomer || {}).id || null,
        customerName:      state.customerName,
        customerEmail:     state.customerEmail,
        customerPhone:     state.customerPhone,
        beans:             sel.map(function (b) { return { id: b.beanId, ratio: b.ratio }; }),
        quantityPerKg:     state.kg,
        deliveryFrequency: state.frequency,
        durationMonths:    state.duration,
        blendDetails:      blendDetails,
        agreementAccepted: true,
        // Checkout'ta ürün görseli çıksın diye tema ayarındaki varyant
        variantId:         config.variantId || null,
      }),
    })
    .then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.error || 'HTTP ' + res.status);
        return data;
      });
    })
    .then(function (data) { window.location.href = data.checkoutUrl; })
    .catch(function (err) {
      if (btn)      { btn.disabled = false;      btn.textContent      = state.step === TOTAL_STEPS ? 'Abonelik Oluştur ve Öde →' : 'İleri →'; }
      if (asideBtn) { asideBtn.disabled = false; asideBtn.textContent = 'Abonelik Oluştur ve Öde'; }
      showError('Hata: ' + (err.message || 'Bilinmeyen hata'));
    });
  }

  /* ── Yardımcılar ── */
  function selectedBeans() {
    if (state.beanStructure === 'single') {
      return state.beans[0].beanId ? [{ beanId: state.beans[0].beanId, ratio: 100 }] : [];
    }
    return state.beans.filter(function (b) { return b.beanId && b.ratio > 0; });
  }

  function findBean(id) {
    return (config.beans || []).find(function (b) { return b.id === id; });
  }

  function calcTotalDeliveries() {
    if (!state.frequency || !state.duration) return 0;
    var freq = (config.frequencyOptions || []).find(function (f) { return f.value === state.frequency; });
    return freq ? freq.perMonth * state.duration : 0;
  }

  function calcPricePerKg() {
    var sel = selectedBeans();
    if (!sel.length || !state.duration) return 0;
    // Süreye göre sunucudan gelen hazır satış fiyatları (TL/kg)
    var table = (config.serverPrices || {})['sub' + state.duration] || {};

    var valid      = sel.filter(function (b) { return b.beanId && parseFloat(table[b.beanId]) > 0; });
    var ratioTotal = valid.reduce(function (s, b) { return s + b.ratio; }, 0);
    if (!valid.length || !ratioTotal) return 0;

    var perKgTL = 0;
    valid.forEach(function (b) {
      perKgTL += parseFloat(table[b.beanId]) * (b.ratio / ratioTotal);
    });
    return perKgTL;
  }

  function calcTotalAmount() {
    var pricePerKg = calcPricePerKg();
    var td = calcTotalDeliveries();
    if (!pricePerKg || !td) return 0;
    return Math.round(pricePerKg * state.kg * td * 100) / 100;
  }

  function freqLabel_() {
    var f = (config.frequencyOptions || []).find(function (o) { return o.value === state.frequency; });
    return f ? f.label : '';
  }

  function showError(msg) {
    var el = document.getElementById('sw-errors');
    if (el) { el.textContent = msg; }
  }

  function clearError() {
    var el = document.getElementById('sw-errors');
    if (el) { el.textContent = ''; }
  }

  function esc(str) {
    return String(str || '').replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  /* ── Start ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
